document.addEventListener('alpine:init', () => {
    Alpine.data('modal', () => ({
        openModal: false,
        toggleModal() {
            this.openModal = ! this.openModal
            if(this.openModal){
                
                document.querySelector('body').style.overflow = 'hidden';
                document.querySelector('body').style.pointerEvents = 'none';
                
            }else {
                document.querySelector('body').style.overflow = 'auto';
                document.querySelector('body').style.pointerEvents = 'auto';
            }
        },
    }))
})
